import { render, staticRenderFns } from "./member-free-tag.vue?vue&type=template&id=4a2a2b69&scoped=true&"
import script from "./member-free-tag.vue?vue&type=script&lang=ts&"
export * from "./member-free-tag.vue?vue&type=script&lang=ts&"
import style0 from "./member-free-tag.vue?vue&type=style&index=0&id=4a2a2b69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a2b69",
  null
  
)

export default component.exports